import { Component } from '@angular/core';
import { DataService } from '../data/data.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NumpadValue } from '../core/components/numpad.component';
import { updateCurrencyAmount } from '../core/components/currency-input-calculations';
import { Router } from '@angular/router';

@Component({
    selector: 'app-cashbox-open-modal',
    template: `
    <div class="modal-header">
      <h4 class="modal-title" i18n>Kasse öffnen</h4>
      <button type="button" class="btn-close" aria-label="Close" i18n-aria-label
              (click)="activeModal.close()"></button>
    </div>
    <div class="modal-body">
      <div class="d-flex flex-column flex-lg-row">
        <div class="d-flex flex-column">
          <div class="d-flex flex-column align-items-center p-3 mb-2 mb-md-3">
            <div class="d-block w-100 d-md-none pb-3" i18n>Ihre Eingabe</div>
            <div class="input-group focus-input-group w-208px w-md-272px">
              <div class="input-group-text bg-white">
                <button type="button" class="btn-close" (click)="revertAmount()"></button>
              </div>
              <app-currency-input class="form-control fs-4 form-control-lg border-start-0" ngbAutofocus [value]="insertedAmount"
                                  (valueChange)="updateAmount($event)"></app-currency-input>
            </div>
          </div>
          <app-numpad theme="dark" [showDecimalZeroes]="true" (buttonPress)="handleNumpadEvent($event)"></app-numpad>
        </div>

        <div class="border-end border-bottom border-medium"></div>

        <div class="vstack p-3 gap-3">
          <div class="d-none d-md-flex justify-content-between align-items-center flex-nowrap">
            <div class="d-flex flex-column flex-nowrap fs-5">
              <span i18n>Ihre Eingabe</span>
              <span class="text-muted fs-6" i18n>(Ist-Bestand)</span>
            </div>
            <span class="fs-4">
              {{insertedAmount | currency}}
            </span>
          </div>

          <div class="d-flex justify-content-between align-items-center">
            <span class="fs-5" i18n>Soll-Bestand</span>
            <span class="fs-4">
              {{dataService.cashBox.cashBalance | currency}}
            </span>
          </div>

          <div class="border-bottom border-medium d-none d-lg-block"></div>

          <div class="d-flex justify-content-between align-items-center" *ngIf="differenceAmount > 0">
            <span class="fs-5" i18n>Überschuss</span>
            <span class="fs-4 text-success">
              {{differenceAmount | currency}}
            </span>
          </div>

          <div class="d-flex justify-content-between align-items-center" *ngIf="differenceAmount < 0">
            <span class="fs-5" i18n>Fehlbetrag</span>
            <span class="fs-4 text-danger">
              {{differenceAmount | currency}}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal-footer justify-content-center align-items-center p-3 p-md-4">
      <button type="button" class="btn btn-lg btn-success text-white w-100 py-3" i18n [disabled]="loading"
              (click)="openCashBox()">
        Kasse öffnen
      </button>
    </div>
  `,
    styles: [`
    :host {
      display: block;
    }
  `],
    standalone: false
})
export class CashBoxOpenModalComponent {
  loading = false;

  insertedAmount = 0;

  get differenceAmount(): number {
    return this.insertedAmount - this.dataService.cashBox.cashBalance;
  }

  constructor(public activeModal: NgbActiveModal,
              public dataService: DataService,
              private readonly router: Router) {
  }

  handleNumpadEvent(value: NumpadValue) {
    const updatedAmount = updateCurrencyAmount(this.insertedAmount, value);
    this.updateAmount(updatedAmount);
  }

  updateAmount(value: number) {
    this.insertedAmount = value;
  }

  revertAmount() {
    this.insertedAmount = 0;
  }

  async openCashBox() {
    this.loading = true;

    try {
      const opened = await this.dataService.openCashBox(this.insertedAmount);
      if (opened) {
        this.activeModal.close();
        // If successfully opened, redirect to main page
        await this.router.navigate(['/']);
      }
    } finally {
      this.loading = false;
    }
  }
}
